import { cn } from "@/lib/utils";

type RiskAiDisclaimerProps = {
  className?: string;
};

export const RiskAiDisclaimer = ({ className }: RiskAiDisclaimerProps) => (
  <p className={cn("text-xs text-tertiary leading-5", className)}>
    Risk detection is powered by AI and can make mistakes.
  </p>
);
